import { usePageMeta } from 'src/hooks';
import { OrganizationContainer } from 'src/containers/Organization';
import { UsersContainer } from 'src/containers/Users';

const OrganizationPage = () => {
  usePageMeta('Organization');

  return (
    <div className="container mx-auto">
      <OrganizationContainer />
      <UsersContainer />
    </div>
  );
};

export default OrganizationPage;
